export default "__VITE_ASSET___dyJv3v7__"